import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "social-links" }
const _hoisted_4 = {
  href: "https://www.facebook.com/computerinforbusiness",
  target: "_blank"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  href: "https://www.linkedin.com/company/computerinfor",
  target: "_blank"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  href: "https://github.com/Groamer",
  target: "_blank"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "copyright-section" }
const _hoisted_14 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_details_table = _resolveComponent("contact-details-table")!
  const _component_double_block = _resolveComponent("double-block")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.displayContactDetails)
          ? (_openBlock(), _createBlock(_component_double_block, { key: 0 }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Contact Details", -1)),
                _createVNode(_component_contact_details_table)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_double_block, null, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Social Media", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", _hoisted_4, [
                _createElementVNode("img", { src: $data.facebookLogo }, null, 8, _hoisted_5),
                _createElementVNode("img", { src: $data.facebookLogoActive }, null, 8, _hoisted_6)
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", _hoisted_7, [
                _createElementVNode("img", { src: $data.linkedinLogo }, null, 8, _hoisted_8),
                _createElementVNode("img", { src: $data.linkedinLogoActive }, null, 8, _hoisted_9)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", _hoisted_10, [
                _createElementVNode("img", { src: $data.githubLogo }, null, 8, _hoisted_11),
                _createElementVNode("img", { src: $data.githubLogoActive }, null, 8, _hoisted_12)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[4] || (_cache[4] = _createElementVNode("a", { href: "/terms_and_conditions" }, "Terms & Conditions", -1)),
        _cache[5] || (_cache[5] = _createTextVNode(" | ")),
        _cache[6] || (_cache[6] = _createElementVNode("a", { href: "/sitemap" }, "Sitemap", -1)),
        _createTextVNode(" | © 2023 - " + _toDisplayString($data.currentYear) + " ConvertFormats | Designed and developed by ", 1),
        _cache[7] || (_cache[7] = _createElementVNode("a", {
          href: "https://www.computerinfor.com",
          target: "_blank"
        }, "ComputerInfor", -1))
      ])
    ])
  ], 64))
}